module.exports = __webpack_public_path__ + "asset/form2--0342de.png";